<template>
	<div>
		<div v-if="!$root.isMobile()">
			<span class="subscription-follow">Preencha os dados da sua conta:</span>

			<radial-progress-bar
				:totalSteps="$t('steps').length + 1"
				:completedSteps="parseInt(currentStep) + 1"
				:diameter="50"
				:strokeWidth="4"
				:innerStrokeWidth="4"
				:animateSpeed="200"
				:isClockwise="true"
				innerStrokeColor="#E7E7E7"
				startColor="#007bff"
				stopColor="#007bff"
				class="radial"></radial-progress-bar>
			<ul>
				<li
					v-for="(step, index) in $t('steps')"
					:class="{
						active: index < currentStep && index != currentStep,
						current: index == currentStep,
					}"
					:key="index"
					@click="change(index)">
					{{ step }}
				</li>
			</ul>
		</div>
		<div v-if="$root.isMobile()">
			<div class="row">
				<div
					class="col-2 mobile-steps"
					v-for="(step, index) in $t('steps')"
					:key="index"
					:class="{
						'active-mobile': index <= currentStep,
					}"></div>
			</div>
		</div>
	</div>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";

export default {
	name: "StepsComponent",
	props: ["currentStep"],
	components: { RadialProgressBar },
	methods: {
		change: function (index) {
			if (index >= this.currentStep) {
				return;
			}

			this.$store.commit("setStep", index < this.currentStep ? index : this.currentStep);
			this.$parent.readyToSubmit = false;

			this.$nextTick(() => {
				this.$parent.validationTrigger = !this.$parent.validationTrigger;

				document.querySelector(".scroll").scrollTo({
					top: 0,
					left: 0,
					behavior: "smooth",
				});
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";

ul {
	list-style: none;
	padding: 0px;
	margin-top: 30px;
}

li {
	padding: 13px 0;
	color: #686361;
	font-family: Montserrat;
	font-size: 16px;
	font-weight: 400;
	letter-spacing: -0.4px;
	line-height: 22px;
}

ul li:before {
	content: "";
	display: inline-block;
	vertical-align: middle;
	width: 15px;
	height: 15px;
	position: relative;
	border-radius: 50%;
	margin-right: 30px;
	margin-left: 10px;
	background-color: #c2c0bf;
}

.current {
	font-weight: bold;
	color: #32302f;
}

.current:before {
	background-color: $blue;
}

.active {
	cursor: pointer;
	padding: 8px 0;
}

.active:hover {
	color: #32302f;
}

.active:before {
	content: "";
	display: inline-block;
	width: 35px;
	height: 35px;
	position: relative;
	border-radius: 50%;
	margin-left: 0px;
	margin-right: 20px;
	background-color: $blue;
	background-image: url("~@/assets/images/icons/check-white.svg");
	background-repeat: no-repeat;
	background-position: 50% 50%;
}

.subscription-follow {
	color: #686361;
	font-family: "Nunito Sans";
	font-size: 16px;
	font-weight: bold;
	letter-spacing: -0.16px;
	line-height: 22px;
}

.radial {
	display: inline-block;
	margin-left: 15px;
}

.mobile-steps {
	height: 3px;
	margin: 0 5px;
	background-color: #c2c0bf;
}

.active-mobile {
	background-color: $blue;
}

@media only screen and (max-width: 1200px) {
	li {
		font-size: 14px;
	}
}

@media only screen and (max-width: 1024px) {
	.row {
		padding: 0px;
	}

	.col-2 {
		max-width: calc(16.6666666667% - 6px);
		padding: 0px;
		margin: 0 3px;
	}
}
</style>
